import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

export function StatCard({ label, value, icon: Icon, trend = 'neutral', change = 0, color = '#000' }) {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700 p-4 shadow-sm">
      <div className="flex items-start justify-between mb-3">
        <span className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase">{label}</span>
        {Icon && <Icon className="w-5 h-5 text-gray-400" />}
      </div>
      <div className="flex items-end gap-2">
        <span className="text-2xl font-bold text-gray-900 dark:text-white">{value}</span>
        {trend !== 'neutral' && (
          <div className="flex items-center gap-1 mb-1">
            {trend === 'up' && <TrendingUp className="w-4 h-4 text-green-600" />}
            {trend === 'down' && <TrendingDown className="w-4 h-4 text-red-600" />}
            <span className={`text-xs font-semibold ${trend === 'up' ? 'text-green-600' : 'text-red-600'}`}>
              {change}%
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
